import { useGlobalStore } from "controller";
import { Helmet } from "react-helmet";

export const CustomHelmet = ({ title }: { title?: string }) => {
  const brandName = useGlobalStore((state) => state.brandName);
  return (
    <Helmet>
      <title>
        {brandName || "DeskDay"}
        {title ? ` | ${title}` : ""}
      </title>
    </Helmet>
  );
};
